export const tag = 'serviceDetailTemplate';
export const load = async () => {
    const { ServiceDetailTemplateComponent } = await import('./service-detail-template.component');
    return {
        component: ServiceDetailTemplateComponent,
    };
};
